import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-video',
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    templateUrl: './video.component.html',
    styleUrl: './video.component.css'
})
export class VideoComponent {
  @Input() videoId!: string;
  @Input() width: string = '';
  @Input() height: string = '';
  @Input() maxWidth: string = '';
  @Input() aspectRatio: any;
  @Input() isVideo: any;
  @Input() fields: any;
  @Input() imagePath: any;
  embedUrl!: SafeResourceUrl;
  thumbnailUrl!: string;
  playVideoFlag = false;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.embedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      `https://www.youtube.com/embed/${this.videoId}?rel=0&autoplay=1`
    );
    this.thumbnailUrl = `https://img.youtube.com/vi/${this.videoId}/hqdefault.jpg`;
  }

  playVideo(): void {
    this.playVideoFlag = true;
  }
}
